// test158
(158 && 0);
